import styled from 'styled-components';
import { getDimension } from 'styled/helpers/getDimension';

export const CardsHeader = styled.h2`
  text-align: center;
  margin-bottom: ${getDimension('size8')};
`;
